import React, { useEffect, useState } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { ALIGN_TYPES } from "constants/align-types";
import { LG, XXL } from "constants/sizes";
import classNames from "classnames";
import { SPACE_BLUE_GRADIANT_THEME_ID } from "segments/segments-service";
import { GRADIANT_WORKOS_IRIS_COLOR_NAME } from "styles/color-consts";
import { lineDistance } from "utils/math";
import { starsClusters, cometLines, stars } from "./stars-clusters-config";
import UniverseStarTagComponent from "./universe-star-tag/universe-star-tag-component";
import UniversStarComponent from "./universe-stars/universe-star-component";
import { componentStyles } from "./monday-universe-homepage-first-fold-component.scss";

const MondayUniverseHomepageFirstFoldComponent = (props) => {
  const { fullParagraph, fullParagraphAdvancedConfig } = props;
  const [clientLoaded, setClientLoaded] = useState(false);

  const renderClusterStars = () => {
    return starsClusters.map((star) => {
      return (
        <div className="star-wrapper" style={{ ...star.position }} key={star.text}>
          <UniverseStarTagComponent starText={star.text} starImage={star.image} starColorName={star.colorName} />
        </div>
      );
    });
  };

  useEffect(() => {
    setClientLoaded(true);
  }, []);

  const renderStars = () => {
    return stars.map((star, index) => {
      return <UniversStarComponent key={`star-${index}`} leftRange={3} rightRange={10} {...star} />;
    });
  };

  // Saving this for debug purposes and moving lines + stars
  // const printMousePos = (event) => {
  //   console.log(`top: ${event.clientY - 80}, left: ${event.clientX - 240}`);
  //   alert(`{top: ${event.clientY - 80}, left: ${event.clientX - 100}}`);
  // };

  const renderComets = () => {
    return cometLines.map((comet, index) => {
      const angle = (Math.atan2(comet.end.top - comet.start.top, comet.end.left - comet.start.left) * 180) / Math.PI;
      const distance = lineDistance(comet.start.left, comet.start.top, comet.end.left, comet.end.top);

      return (
        <div
          key={`comet-${index}`}
          className={classNames("comet-line", { underline: comet.isUnderline })}
          style={{ transform: `rotate(${angle}deg)`, width: distance, ...comet.start }}
        />
      );
    });
  };

  return (
    <div className="monday-universe-homepage-first-fold-component">
      <div className="stars-canvas">
        {renderClusterStars()}
        {renderComets()}
        {clientLoaded && renderStars()}
      </div>
      <div className="paragraph-wrapper">
        <FullParagraph
          {...fullParagraphAdvancedConfig}
          {...fullParagraph}
          topic={{}}
          textAlign={ALIGN_TYPES.CENTER}
          titleClassName="universe-title"
        />
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default MondayUniverseHomepageFirstFoldComponent;

MondayUniverseHomepageFirstFoldComponent.defaultProps = {
  theme: SPACE_BLUE_GRADIANT_THEME_ID,
  fullParagraph: {
    title: "A platform built for a new way of working",
    body: "manage everything with monday.com Work OS",
    buttonConfig: { buttonType: "Signup", buttonColor: GRADIANT_WORKOS_IRIS_COLOR_NAME }
  },
  fullParagraphAdvancedConfig: {
    titleSize: XXL,
    textSize: LG,
    titleWidth: "800px",
    spaceFromParagraph: "32px",
    buttonTopMargin: "64px"
  }
};
